import React from "react";
import { useParams } from "react-router-dom";

import { useOptic } from "@/hooks/useOptic";
import { OpticHeader } from "@/components/qpcr/OpticHeader";
import { SampleSetPlot } from "@/components/qpcr/SampleSetPlot";
import { DumpLoader } from "@/components/qpcr/DumpLoader";
import { Loading } from "@/components/common/Loading";

export function OpticDetail() {
  const { opticId = "" } = useParams();
  const { data, isLoading, error } = useOptic(opticId);

  if (isLoading) return <Loading />;
  if (error || !data) {
    return <p className="text-danger-text">Could not load run.</p>;
  }

  return (
    <div className="space-y-lg">
      <OpticHeader optic={data} />

      <section className="space-y-md">
        <h2 className="text-sm font-medium">Sample sets</h2>
        {data.sample_sets.length === 0
          ? <p className="text-textLight text-sm">No sample sets recorded for this run.</p>
          : data.sample_sets.map(ss => (
              <SampleSetPlot key={ss.id} sampleSet={ss} />
            ))}
      </section>

      <section className="space-y-sm">
        <h2 className="text-sm font-medium">Raw dump</h2>
        <DumpLoader opticId={opticId} hasDump={data.has_dump} />
      </section>
    </div>
  );
}
